import React, { useEffect, useState } from 'react';
import healthBeauty from 'src/assets/images/calendar-icon.png';
import { Link } from 'react-router-dom';
import { Skeleton } from '@mui/material';
import httpRequest from 'src/helpers/httpRequest';
import { toast } from 'react-toastify';

interface IMainCategoryObj {
    _id: string;
    categoryName: string;
};
interface ISubCategoryObj {
    _id: string;
    mainCategoryId: string;
    subCategoryName: string;
};
interface IChildCategoryObj {
    _id: string;
    mainCategoryId: string;
    subCategoryId: string;
    childCategoryName: string;
};

interface IResponse {
    mainCategory: IMainCategoryObj[];
    subCategory: ISubCategoryObj[];
    childCategory: IChildCategoryObj[];
};

const PharmacyBanner: React.FC<{ loader: boolean; mainBanner: string }> = ({
    loader = false, mainBanner = null
}) => {
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [mainCategories, setMainCategories] = useState<IMainCategoryObj[]>([]);
    const [subCategories, setSubCategories] = useState<ISubCategoryObj[]>([]);
    const [childCategories, setChildCategories] = useState<IChildCategoryObj[]>([]);
    const fetch = async () => {
        setIsLoader(true);
        const { res, err } = await httpRequest<IResponse>({ path: "/main-category/home/all-categories" });
        if (res) {
            const { mainCategory = [], subCategory = [], childCategory = [] } = res;
            setMainCategories(mainCategory);
            setSubCategories(subCategory);
            setChildCategories(childCategory);
        } else {
            toast(err, { type: "error" });
        }
        setIsLoader(false);
    };
    useEffect(() => {
        fetch();
    }, []);
    return (
        <>
            <div className='banner-hover-toggle relative'>
                <div className='banner-pharmacy-left-side'>
                    {mainCategories?.map(main => (
                        <div key={main?._id} className='health-beauty-main'>
                            <Link to={`/pharmacy/main-category/${main?._id}/view`} className="flex items-center gap-2">
                                <img src={healthBeauty} alt='health-beauty' />
                                <span className='text-[#707070] font-Poppins-Regular span-text-hover-yellow font-size-16px'>{main?.categoryName || ""}</span>
                            </Link>
                            <div className='health-beauty-toggle-hover'>
                                <div className='health-beauty-toggle-hover-box'>
                                    {subCategories?.filter(v => v?.mainCategoryId === main?._id)?.map(sub => (
                                        <div key={sub?._id}>
                                            <Link to={`/pharmacy/sub-category/${sub?._id}/view`} className='theme-color-green bottom-border-width-categries font-Poppins-Medium font-size-16px'>{sub?.subCategoryName || ""}</Link>
                                            <div className='top-categories-child-cat'>
                                                {childCategories?.filter(v => v?.subCategoryId === sub?._id)?.map(child => (
                                                    <Link key={child?._id} to={`/pharmacy/child-category/${child?._id}/view`} className='text-[#8B8A8A] block hover:text-[#09887F] mb-1 font-Poppins-Regular font-size-14px'>{child?.childCategoryName || ""}</Link>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className='banner-pharmacy-right-side'>
                    {loader
                        ?
                        <Skeleton variant="rounded" className="pharmacy-banner-first-img" />
                        :
                        <img
                            className='pharmacy-banner-first-img'
                            src={`${mainBanner}`}
                            alt='banner-dummy-pic'
                        />
                    }
                </div>
            </div>
        </>
    );
};

export default PharmacyBanner;